// src/components/Base/BaseTableAction.tsx
import React from "react";
import "./styles/BaseTableAction.css";

type Props = {
  /** Icono (un <svg> o cualquier ReactNode). Si no lo envías, mostrará `label`. */
  icon?: React.ReactNode;
  /** Texto alternativo si no hay icono (o para accesibilidad). */
  label?: string;
  onClick: () => void;
  /** Tooltip / aria-label */
  title: string;
  disabled?: boolean;
};

const BaseTableAction: React.FC<Props> = ({ icon, label, onClick, title, disabled }) => (
  <button
    className={`table-action-btn${disabled ? " is-disabled" : ""}`}
    onClick={onClick}
    type="button"
    title={title}
    aria-label={title}
    disabled={disabled}
  >
    {icon ?? label}
  </button>
);

export default BaseTableAction;
